import {ListResponseType, TagSerializedType} from 'sweet-types';

export const tags_list_fixture: ListResponseType<TagSerializedType> = {
  count: 5,
  next: null,
  previous: null,
  results: [
    {
      id: 9,
      url: '/api/v1/tags/9/',
      name: 'Accounting and Finance',
      slug: 'Accounting and Finance',
      procedure_count: 0,
      policy_count: 0,
      proceduregroup_count: 0,
    },
    {
      id: 8,
      url: '/api/v1/tags/8/',
      name: 'Human Resource Management',
      slug: 'Human Resource Management',
      procedure_count: 0,
      policy_count: 0,
      proceduregroup_count: 0,
    },
    {
      id: 11,
      url: '/api/v1/tags/11/',
      name: 'Marketing',
      slug: 'Marketing',
      procedure_count: 1,
      policy_count: 0,
      proceduregroup_count: 0,
    },
    {
      id: 12,
      url: '/api/v1/tags/12/',
      name: 'Purchasing',
      slug: 'Purchasing',
      procedure_count: 0,
      policy_count: 0,
      proceduregroup_count: 0,
    },
    {
      id: 7,
      url: '/api/v1/tags/7/',
      name: 'Research and Development',
      slug: 'Research and Development',
      procedure_count: 0,
      policy_count: 0,
      proceduregroup_count: 0,
    },
  ],
  num_pages: 1,
};
